import { ICoreTimings } from '@pp/core';

export const MWCoreTimings: ICoreTimings = {
  bettingWindow: 12_000,
  bettingLastCall: 5_000,
  gameCommunicationDelay: 2_000,
  studioLatency: 1_000,
  videoDelayBoundaryMin: 2000,
  videoDelayBoundaryMax: 4_500,
};
